<template>
    <div class="spinner">
        <svg
            class="spinner-inner"
            :width="selectedSize"
            :height="selectedSize"
            viewBox="0 0 66 66"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                class="path"
                fill="none"
                stroke-width="6"
                stroke-linecap="round"
                cx="33"
                cy="33"
                r="30"
            ></circle>
        </svg>
    </div>
</template>

<script>
    const sizes = {
        small: '16px',
        medium: '24px',
        large: '32px',
    };

    export default {
        name: 'Spinner',
        props: {
            size: {
                required: false,
                type: String,
                default: 'medium',
                validator: value => Object.prototype.hasOwnProperty.call(sizes, value),
            },
        },
        computed: {
            selectedSize() {
                return sizes[this.size];
            },
        },
    };
</script>
